import React, { useState, useEffect } from 'react';

import { IconButton, Tooltip } from '@mui/material';
import { isLocalUser } from 'Utils/account/utils';

import ShareModal from './ShareModal';
import { Share } from '@mui/icons-material';
import { FielderHard } from '@core/theme/baseTheme';

const TopMenuShare = ({ user, lan }) => {
	const [show, setShow] = useState(false);
	const [showModal, setShowModal] = useState(false);

	useEffect(() => {
		setShow(isLocalUser(user));
	}, [user]);

	const handleShowModal = () => {
		setShowModal(!showModal);
	};

	return (
		<>
			{show && (
				<>
					<Tooltip title={lan.share}>
						<IconButton
              onClick={handleShowModal}
              sx={{
                p: 0,
                '& .top-menu-icon': {
                  color: 'text.disabled',
                },
                '&:hover .top-menu-icon': {
                  color: FielderHard,
                },
              }}
            >
							<Share fontSize="medium" className="top-menu-icon"/>
						</IconButton>
					</Tooltip>
					{showModal && <ShareModal closeDialog={handleShowModal} lan={lan} />}
				</>
			)}
		</>
	);
};

export default TopMenuShare;
